import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import about_en from "./locales/about_en.json";
import about_ru from "./locales/about_ru.json";
import home_page_en from "./locales/home_page_en.json";
import home_page_ru from "./locales/home_page_ru.json";
import contact_en from "./locales/contact_en.json";
import contact_ru from "./locales/contact_ru.json";
import navigation_en from "./locales/navigation_en.json";
import navigation_ru from "./locales/navigation_ru.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: { ...en, ...about_en, ...home_page_en, ...contact_en, ...navigation_en }
    },
    ru: {
      translation: { ...ru, ...about_ru, ...home_page_ru, ...contact_ru, ...navigation_ru }
    }
  },
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
